import MailLink from 'features/SetupTelecom/MailLink'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import telcoApi from 'services/api/telcoSetup'

import { getOtherHotelDetails } from '../../actions/hotelDetails'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles/index'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import HotelInfoBanner from './HotelInfoBanner/index'
import styles from './HotelNumberPicker.module.scss'
import NumberList from './NumberList/index'
import SearchRow from './SearchRow/index'

const bandwidthErrorMessages = [
  'The provided street address could not be verified. Please submit a valid street address',
  'The verifiable address closest to the submitted access is included below. Please use that street address or another valid street address in your next request',
  'The provided street address could not be verified. Please submit a valid street address from telcosetup'
]

const HotelNumberPicker = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [searchResults, setSearchResults] = useState(null)
  const [numberList, setNumberList] = useState([])
  const [hasBandwidthError, setHasBandwidthError] = useState(false)

  const { addToast } = useToasts()

  const dispatch = useDispatch()

  const history = useHistory()

  const { id: subsidiaryId } = useParams()

  const getNumbers = async (areaCode, pattern) => {
    setNumberList([])
    setLoading(true)

    telcoApi
      .numberSearch({ areaCode, pattern })
      .then(res => {
        setSearchResults(res.numbers)
      })
      .catch(err => {
        addToast(err.toString(), { appearance: 'error', autoDismiss: true })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const { [subsidiaryId]: hotelDetails } = useSelector(
    s => s.hotelDetails.otherSubsidiaries
  )

  const sendNumbers = async () => {
    setLoading(true)

    telcoApi
      .buyNumber({ numbersToBuy: numberList, subsidiaryId })
      .then(() => {
        setLoading(false)
        history.push('/hotelDetails')
      })
      .catch(err => {
        setLoading(false)
        if (
          bandwidthErrorMessages.some(bandwidthErrorMessage =>
            err.toString().includes(bandwidthErrorMessage)
          )
        ) {
          setHasBandwidthError(true)
        } else {
          setError(err.toString())
        }
      })
  }

  useEffect(() => {
    if (!hotelDetails) {
      dispatch(getOtherHotelDetails(subsidiaryId))
    }
  }, [dispatch, hotelDetails, subsidiaryId])

  if (!hotelDetails) {
    return <LoadingIndicator />
  }

  const numberOfPhonesToSelect = 1

  function toggleNumber(number) {
    if (numberList.includes(number))
      setNumberList(numberList.filter(item => item !== number))
    else {
      if (numberList.length < numberOfPhonesToSelect) {
        setNumberList([...numberList, number])
      }
    }
  }

  return (
    <div className={styles.page}>
      <CustomHeader
        title="Buy a proxy number"
        subtitle={hotelDetails.hotelName}
        width={1000}
      />
      <HotelInfoBanner hotel={hotelDetails} />
      <div className={styles.container}>
        <SearchRow
          loading={loading}
          handleSearch={getNumbers}
          reservationHotline={hotelDetails.reservationHotLine}
          stateCode={hotelDetails.stateCode}
        />
        <NumberList
          selectedNumbers={numberList}
          list={searchResults}
          toggleNumber={number => toggleNumber(number)}
        />
      </div>
      <div className={styles.flexButtonsHolder}>
        <NavLink to="/hotelDetails">
          <button className={styles.secondaryButton}>Cancel</button>
        </NavLink>
        <button
          disabled={loading || numberList.length !== numberOfPhonesToSelect}
          onClick={sendNumbers}
          className={styles.primaryButton}
        >
          Buy & save phone number
        </button>
      </div>
      {hasBandwidthError && (
        <p className={styles.error}>
          Address rejected by bandwidth. <MailLink {...hotelDetails}>Click here</MailLink>{' '}
          to create an email with this hotel's data and reach them.
        </p>
      )}
      {error && <p className={styles.error}>{error}</p>}
    </div>
  )
}

export default HotelNumberPicker
